export { VpPluginDetailsForm } from './VpPluginDetailsForm';



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpPluginDetailsForm/index.js